import {
  Mobility,
  Healthcare,
  Shopping,
  WaterEcosystem,
  Education,
  Knowledge,
  // Other,
} from './icons';

import { ALWAYS_VISIBLE_HOTSPOT_IDS } from '../../components/NTVOutdoorHotspotStyle/constants';

// Re-export for backwards compatibility
export { ALWAYS_VISIBLE_HOTSPOT_IDS };
export const ALWAYS_VISIBLE_HOTSPOT_ID = ALWAYS_VISIBLE_HOTSPOT_IDS[0];

export const typeFilters = {
  'tien-ich': [
    {
      id: 'di-chuyen',
      icon: Mobility,
      label: 'Di chuyển',
      defaultOrientation: [-478.13526551642383, -27.49430953479084, 500],
    },
    {
      id: 'he-sinh-thai-mat-nuoc',
      icon: WaterEcosystem,
      label: 'Hệ sinh thái mặt nước',
      defaultOrientation: [85.05460503450367, -61.154185191842195, 500],
    },
    {
      id: 'suc-khoe',
      icon: Healthcare,
      label: 'Sức khỏe',
      defaultOrientation: [-500, -30.10560266872081, 46.906146657677894],
    },
    {
      id: 'giao-duc',
      icon: Education,
      label: 'Giáo dục',
      defaultOrientation: [-423.32661874054304, 7.885724680289271, -500],
    },
    {
      id: 'he-sinh-thai-tri-thuc-cong-nghe',
      icon: Knowledge,
      label: 'Khu công nghệ cao',
      defaultOrientation:[-500, 123.01581690942793, -482.7949073428553],
    },
    {
      id: 'mua-sam-giai-tri',
      icon: Shopping,
      label: 'Mua sắm & Giải trí',
      defaultOrientation: [-500, -59.55154708462463, -22.66036684906796],
    },
  ],
};

export const DEFAULT_ORIENTATION = [
  -208.71524384702548, -70.00994044396413, 500,
];

export const types = [
  {
    id: 'tien-ich',
    label: 'Tất cả tiện ích',
    labelShort: 'Tiện ích',
  },
];

export const hotspotIds = {
  'di-chuyen': [
    '6a02c6bd47b0fda4964326f8', // Metro bến xe suối tiên
    '6a02dcf447b0fda4964384d7', // Bến Xe Miền Đông Mới
    '6a02ded747b0fda496439269', // Sân Bay Quốc tế Long Thành
    '6a02dee747b0fda496439303', // Trung tâm hành chính Thủ Thiêm
    '6a02def847b0fda49643938c', // Chợ Bến Thành
    '6a6c4e9ac6222a78db0fad0c',
    '6a6c4ef7c6222a78db0fad56',
    '6a6c4f3ac6222a78db0fad92',
  ],
  'he-sinh-thai-mat-nuoc': [
    // '690b2fd1fbeb572cfafcfc34', // Hồ Đá
    '6a38ab03163b8b61734dd3e1', // Ho Da
    // '690b2ebafbeb572cfafcfb24', // Hồ Bình An
    '6a38ab93163b8b61734dd47d', //Ho Binh An
    '6a151a6728a9d9dbfa9f8f98', // Công viên ven hồ Bình An
  ],
  'suc-khoe': [
    '6a02dd0647b0fda496438550', // Bệnh Viện Đa Khoa Quốc Tế Hoàn Mỹ
    '6a02dd1647b0fda4964385b7', // Bệnh Viện Ung Bướu CS2
  ],
  'giao-duc': [
    '6a02ddc947b0fda496438a5f', // Trường Tiểu học Đông Hoà B
    '6a02ddda47b0fda496438ad0', // Trường THCS Đông Hoà
    '6a02dde847b0fda496438b37', // Trường THPT Dĩ An
    '6a02ddf547b0fda496438bbb', // Trường THPT Linh Trung
    '6a02dea147b0fda4964390ac', // Hệ thống Trường ĐH Quốc Gia
  ],
  'he-sinh-thai-tri-thuc-cong-nghe': [
    // '6a02deae47b0fda496439114', // Khu Công Nghệ Cao
    '6a6c4da5c6222a78db0fac47',
  ],
  'mua-sam-giai-tri': [
    // '6a38aab7163b8b61734dd373', // Chợ Đông Hòa
    '6a38ab52163b8b61734dd437', // KDL Suối Tiên
    '6a02dd2847b0fda49643861a', // TTTM Go! Dĩ An
    '6a02dd4447b0fda4964386de', // Vincom Thủ Đức
    '6a02dd5447b0fda496438761', // Vincom Plaza Lê Văn Việt
    '6a02dd6347b0fda4964387bc', // Vincom Mega Mall
    '6a02dd8f47b0fda4964388e9', // Sân Golf Thủ Đức
    // '690b2e80fbeb572cfafcfaf6', // Công viên văn hoá Suoi Tien (old)
    '6a02dec847b0fda4964391f8', // Công viên Văn Hoá Lịch Sử Dân Tộc
  ],
  // 'khac': [
  // ],
};

// Hotspots to show on initial load
export const featuredHotspotIds = [
  ...ALWAYS_VISIBLE_HOTSPOT_IDS, // NEWSTAR & others - always visible
  '6a02dea147b0fda4964390ac', // Hệ thống Trường ĐH Quốc Gia
  '6a02c6bd47b0fda4964326f8', // Metro Bến Xe Suối Tiên
  '6a02dcf447b0fda4964384d7', // Bến Xe Miền Đông Mới
  '6a02dd1647b0fda4964385b7', // Bệnh Viện Ung Bướu CS2
  '6a02dd0647b0fda496438550', // Bệnh Viện Đa Khoa Quốc Tế Hoàn Mỹ
  '6a02dd6347b0fda4964387bc', // Vincom Mega Mall
  '6a02def847b0fda49643938c', // Chợ Bến Thành
  '6a02dee747b0fda496439303', // Trung tâm hành chính Thủ Thiêm
  '6a15178228a9d9dbfa9f6946', // Sân bay Tân Sơn Nhất
];

// All hotspot IDs combined (for "show all")
export const allHotspotIds = [
  ...Object.values(hotspotIds).flat(),
  ...ALWAYS_VISIBLE_HOTSPOT_IDS, // NEWSTAR & others
];
